export interface LogsFileExporterPlugin {
  // only for android since we have to batch the data
  exportLogs(options: { fileName: string }): Promise<{ value: any }>;
  addLogs(options: { value: any }): Promise<{ value: any }>;

  // ios
  exportLogs(options: { logs: any; fileName: string }): Promise<{ value: any }>;
}
